import { faqDataService } from './services';
import { FaqCard, FaqItemPage } from "./components";
import { faUserGear } from "@fortawesome/free-solid-svg-icons";
import { IModuleConfig } from "../../interfaces";
import { ModuleTypeEnum } from "../../enums";
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
} from "./components/toolbar-items";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: 'faqs',
  name: 'FAQs',
  view_permission: UserPermissions.viewFaqs,
  edit_permission: UserPermissions.editFaqs,
  icon: faUserGear,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: FaqCard,
    itemPage: FaqItemPage
  },
  services: {
    getByPage: faqDataService.getByPage,
    getSingle: faqDataService.getSingle,
    create: faqDataService.create,
    update: faqDataService.update
  },
  utilities: {
    extractKey: (d: any) => d._id,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.email_address;
    }
  },
  toolbarItems: {
    library: [AddButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton]
  }
};

export default config;
